import PageHeader from '../commons/PageHeader';

function Logout() {
  return <PageHeader title='Logged Out' />;
}

export default Logout;
